export default __webpack_public_path__ + "static/media/arrow_history.7cbb08f2.svg";